import {
	BlurModal,
	ModalHeader,
	UsersAdd,
} from '@aleph/shared-components';

import useRedditTeamMutationStore from 'wb-reddit/app/routes/teams/hooks/useRedditTeamMutationStore';
import RedditTeamMutator from 'wb-reddit/app/routes/teams/mutator/teamMutator';
import RedditTeamEditMutator from 'wb-reddit/app/routes/teams/mutator/teamEditMutator';
import { HandleUpdateTeamRow, TeamRow } from 'wb-reddit/app/routes/teams/container';
import { SetShowConfirmActionDialog } from 'wb-reddit/app/routes/hooks/useConfirmAction';
import { useTranslation } from 'react-i18next';
import useSaveBeforeExitDialog from 'wb-reddit/app/routes/hooks/useSaveBeforeExitDialog';

interface IProps {
	updateRow: HandleUpdateTeamRow
}

export interface MutatorProps {
	updateRow: HandleUpdateTeamRow
	setShouldShowSaveBeforeExit: SetShowConfirmActionDialog
	beforeClose?: () => void
	row: TeamRow
}

const RedditTeamMutatorContainer = ({ updateRow }: IProps) => {
	const { mutatingTeam, setMutatingTeam } = useRedditTeamMutationStore();
	const { t } = useTranslation();

	const isUpdate = !!mutatingTeam?.userGroupId;

	const {
		beforeClose,
		dialog: saveBeforeExitModal,
		setShouldPromptOnClose: setShouldShowSaveBeforeExit,
	} = useSaveBeforeExitDialog({
		onConfirm: () => setMutatingTeam(undefined),
	});

	if (!mutatingTeam) {
		return null;
	}

	return (
		<BlurModal
			header={
				<ModalHeader
					icon={
						<UsersAdd
							height={24}
							width={24}
						/>
					}
					title={isUpdate ? mutatingTeam.userGroupName : t('sc: team.create_new', 'Create new team')}
					onClose={beforeClose}
				/>
			}
			blur={isUpdate}
			onClose={beforeClose}
			className="z-modal"
		>
			{isUpdate
				? (
					<RedditTeamEditMutator
						updateRow={updateRow}
						setShouldShowSaveBeforeExit={setShouldShowSaveBeforeExit}
						row={mutatingTeam}
					/>
				)
				: (
					<RedditTeamMutator
						updateRow={updateRow}
						setShouldShowSaveBeforeExit={setShouldShowSaveBeforeExit}
						beforeClose={beforeClose}
						row={mutatingTeam}
					/>
				)
			}
			{saveBeforeExitModal}
		</BlurModal>
	);
};

export default RedditTeamMutatorContainer;
